<div class="quiz-list container-xxl py-6 pt-0">
  <!-- No H1 here: the toolbar above already prints "แบบฝึกหัด" as the page
       title, and the two sat 120px apart saying the same word. The search
       block below opens with the descriptive line instead. -->

  <!-- TODO wait confirm api -->
  <!-- <div class="d-flex flex-wrap align-items-center justify-content-end mb-6">
    <a class="btn btn-light-primary btn-sm" routerLink="/profile/monitor/skills" data-testid="skills-link">
      {{ "QUIZ.MY_SKILLS" | translate }}
    </a>
  </div> -->

  @if (isLoading()) {
  <div class="skeleton h-45px w-100 mw-500px mb-8" data-testid="quiz-list-loading"></div>
  <div class="row g-5">
    <ng-container *ngTemplateOutlet="quizCardSkeleton"></ng-container>
    <ng-container *ngTemplateOutlet="quizCardSkeleton"></ng-container>
    <ng-container *ngTemplateOutlet="quizCardSkeleton"></ng-container>
    <ng-container *ngTemplateOutlet="quizCardSkeleton"></ng-container>
    <ng-container *ngTemplateOutlet="quizCardSkeleton"></ng-container>
    <ng-container *ngTemplateOutlet="quizCardSkeleton"></ng-container>
  </div>
  } @else if (!hasAnyQuiz()) {
  <div class="card min-h-60" data-testid="quiz-empty">
    <div class="card-body d-flex justify-content-center">
      <div class=" empty-state">
        <span class="empty-state__mark">
          <app-keenicon name="note-2" class="fs-2tx"></app-keenicon>
        </span>
        <p class="empty-state__title">{{ "QUIZ.EMPTY" | translate }}</p>
        <p class="empty-state__body">{{ "QUIZ.EMPTY_HINT" | translate }}</p>
        <a class="btn btn-primary" routerLink="/online-class">{{ "MENU.ONLINE_CLASS" | translate }}</a>
      </div>
    </div>
  </div>
  } @else {
  <!-- One line of copy and one field, the way the 2021 คลังข้อสอบ page opened.
         The grid below is a wall of long, similar titles that all begin with the
         same words, so reading it is the slowest way to find anything in it. -->
  <div class="pill-search mb-8">
    <p class="pill-search__title">{{ "QUIZ.SEARCH_TITLE" | translate }}</p>
    <div class="pill-search__field">
      <span class="pill-search__icon" aria-hidden="true">
        <app-keenicon name="magnifier" class="fs-3"></app-keenicon>
      </span>
      <input type="search" class="pill-search__input" data-testid="quiz-search" [value]="search()"
        [attr.aria-label]="'QUIZ.SEARCH_PLACEHOLDER' | translate"
        [attr.placeholder]="'QUIZ.SEARCH_PLACEHOLDER' | translate" (input)="onSearch($any($event.target).value)" />
      @if (search().trim().length) {
      <button type="button" class="pill-search__clear" [attr.aria-label]="'QUIZ.SEARCH_CLEAR' | translate"
        (click)="clearSearch()">×</button>
      }
    </div>
  </div>

  <!-- A search that finds nothing is not the same as having nothing to do,
         and it must never look like it: the way out is on the panel. -->
  @if (noSearchResults()) {
  <div class="card" data-testid="pill-search-empty">
    <div class="card-body is-empty">
      <p class="fs-5 text-muted mb-4">{{ "QUIZ.SEARCH_EMPTY" | translate }}</p>
      <button type="button" class="btn btn-light-primary" (click)="clearSearch()">
        {{ "QUIZ.SEARCH_CLEAR" | translate }}
      </button>
    </div>
  </div>
  }

  <div class="row g-5" data-testid="quiz-list">
    @for (quiz of courseQuizzes(); track quiz.id) {
    <div class="col-md-6 col-xl-4">
      <div class="card h-100">
        <div class="card-body d-flex flex-column">
          <!-- A mark, so a screen of six quiz cards has something to look
                   at besides six paragraphs of grey text. It is the course's
                   own subject art — the same one the catalogue and the landing
                   strip use for that category. -->
          <div class="quiz-card__head">
            <span class="quiz-card__mark"><img [src]="art(quiz)" alt="" /></span>
            <span class="quiz-card__title">{{ quiz.title }}</span>
            @if (quiz.kind === 'practice') {
            <span class="badge badge-light-info flex-shrink-0">{{ "QUIZ.KIND_PRACTICE" | translate }}</span>
            }
          </div>

          @if (quiz.course_name) {
          <span class="text-muted fs-7 mb-3">{{ quiz.course_name }}</span>
          }

          <div class="quiz-card__facts">
            <span>{{ "QUIZ.QUESTION_COUNT" | translate }} <b>{{ quiz.question_count }}</b></span>
            <span>{{ "QUIZ.PASS_PERCENT" | translate }} <b>{{ quiz.pass_percent }}%</b></span>
          </div>

          @if (best(quiz); as result) {
          <!-- The best score as a bar rather than a coloured pill: same
                     reading as the result page, and the number is printed next
                     to it instead of being the pill. -->
          <div class="quiz-best" data-testid="quiz-best">
            <!-- The marks as well as the percent. The percent is
                       mark-weighted, so on a card that also prints "จำนวนข้อ 5"
                       a bare "75%" invited arithmetic that does not work. -->
            <div class="quiz-best__row">
              <span class="quiz-best__label">{{ "QUIZ.BEST_RESULT" | translate }}</span>
              <span class="quiz-best__value">
                {{ result.score }}/{{ result.max_score }}
                <span class="quiz-best__percent">{{ result.percent }}%</span>
              </span>
            </div>
            <span class="quiz-best__track">
              <span class="quiz-best__fill" [class.is-pass]="result.passed" [style.width.%]="result.percent"></span>
            </span>
            <a class="quiz-best__link" [routerLink]="['/online-class/quiz/result', result.id]">
              {{ "QUIZ.VIEW_RESULT" | translate }} →
            </a>
          </div>
          }

          <div class="mt-auto">
            @if (best(quiz) && !quiz.allow_retake) {
            <button class="btn btn-light w-100" disabled>{{ "QUIZ.NO_RETAKE" | translate }}</button>
            } @else {
            <!-- Tonal, not solid. Every card on this screen offers the
                       same action; six filled brand bars down the page rank
                       nothing and read as a chore rather than an invitation. -->
            <button class="btn btn-light-primary w-100 fw-bold" type="button" data-testid="quiz-start"
              (click)="start(quiz)">
              {{ best(quiz) ? ("QUIZ.RETAKE" | translate) : ("QUIZ.START" | translate) }}
            </button>
            }
          </div>
        </div>
      </div>
    </div>
    }
  </div>

  <!-- Personal drills, kept out of the main grid. -->
  @if (practiceQuizzes().length) {
  <div class="separator my-10"></div>
  <div class="d-flex flex-column mb-5">
    <h2 class="fs-4 fw-bold mb-1">{{ "QUIZ.MY_DRILLS" | translate }}</h2>
    <span class="fs-7 text-gray-600">{{ "QUIZ.MY_DRILLS_HINT" | translate }}</span>
  </div>
  <div class="row g-5" data-testid="practice-list">
    @for (quiz of practiceQuizzes(); track quiz.id) {
    <div class="col-md-6 col-xl-4">
      <div class="card h-100 border border-gray-200">
        <div class="card-body d-flex flex-column">
          <div class="d-flex align-items-start justify-content-between mb-2">
            <span class="fs-5 fw-semibold">{{ quiz.title }}</span>
            <span class="badge badge-light-info flex-shrink-0">{{ "QUIZ.KIND_PRACTICE" | translate }}</span>
          </div>
          <div class="text-muted fs-7 mb-4">
            {{ "QUIZ.QUESTION_COUNT" | translate }} {{ quiz.question_count }}
          </div>

          @if (best(quiz); as result) {
          <div class="quiz-best">
            <div class="quiz-best__row">
              <span class="quiz-best__label">{{ "QUIZ.BEST_RESULT" | translate }}</span>
              <span class="quiz-best__value">
                {{ result.score }}/{{ result.max_score }}
                <span class="quiz-best__percent">{{ result.percent }}%</span>
              </span>
            </div>
            <span class="quiz-best__track">
              <span class="quiz-best__fill" [class.is-pass]="result.passed" [style.width.%]="result.percent"></span>
            </span>
            <a class="quiz-best__link" [routerLink]="['/online-class/quiz/result', result.id]">
              {{ "QUIZ.VIEW_RESULT" | translate }} →
            </a>
          </div>
          }

          <button class="btn btn-light-primary w-100 mt-auto" type="button" (click)="start(quiz)">
            {{ best(quiz) ? ("QUIZ.RETAKE" | translate) : ("QUIZ.CONTINUE_DRILL" | translate) }}
          </button>
        </div>
      </div>
    </div>
    }
  </div>
  }
  }
</div>

<ng-template #quizCardSkeleton>
  <div class="col-md-6 col-xl-4">
    <div class="card h-100">
      <div class="card-body d-flex flex-column">
        <div class="d-flex align-items-center gap-3 mb-4">
          <div class="skeleton w-45px h-45px rounded"></div>
          <div class="skeleton h-20px flex-grow-1"></div>
        </div>
        <div class="skeleton h-15px w-50 mb-4"></div>
        <div class="d-flex flex-wrap gap-4 mb-6">
          <div class="skeleton h-15px w-100px"></div>
          <div class="skeleton h-15px w-90px"></div>
        </div>
        <div class="skeleton h-8px w-100 mt-auto mb-4"></div>
        <div class="skeleton h-40px w-100"></div>
      </div>
    </div>
  </div>
</ng-template>